import { Stack } from '@mui/material';

import { useColors } from '../ThemeProvider';

interface Props {
  activeStep: number;
  steps: string[];
  activeColor?: string;
  inactiveColor?: string;
}

export function Stepper({ activeStep, steps, activeColor, inactiveColor }: Props) {
  const { secondary, grey } = useColors();
  const filledColor = activeColor ?? secondary;
  const emptyColor = inactiveColor ?? grey;

  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      {steps.map((step, i) => (
        <Stack
          key={step}
          width="3rem"
          borderRadius={'1rem'}
          height={activeStep === i ? '0.25rem' : '0.125rem'}
          sx={{ background: activeStep >= i ? filledColor : emptyColor }}
        />
      ))}
    </Stack>
  );
}
